import bugliftproject from '../assets/images/bugliftproject.png';

const Buglift = () => {
  return (
    <div>
      <a href='#projects'><strong>MERN</strong> App</a>
      <img src={bugliftproject} alt='buglift' className='' />
    </div>
  )
}

export default Buglift;